import { render, staticRenderFns } from "./FormDialog.vue?vue&type=template&id=3a564e18&scoped=true"
import script from "./FormDialog.vue?vue&type=script&lang=js"
export * from "./FormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a564e18",
  null
  
)

export default component.exports